import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hf-selector-link',
  templateUrl: './selector-link.component.html',
  styleUrls: ['./selector-link.component.scss']
})
export class SelectorLinkComponent {
  @Input()
  public value: string;

  @Input()
  public label: string;

  @Input()
  public placeholder: string;

  @Input()
  public readonly: boolean;

  @Input()
  public isInvalid: boolean;

  @Input()
  public showClearButton = false;

  @Output()
  public clearRequested = new EventEmitter<void>();

  public onClearClicked(event: MouseEvent): void {
    event.stopPropagation();
    this.clearRequested.emit();
  }
}
